import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import FaceitFinder from "./pages/FaceitFinder";
import Footer from "./pages/Footer";
import DonateModal from "./components/DonateModal";

const App = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <Router>
            <div className="app">
                <Routes>
                    <Route path="/" element={<FaceitFinder openModal={openModal} />} />
                    <Route path="/profile/:steamId" element={<FaceitFinder openModal={openModal} />} />
                </Routes>
                <Footer openModal={openModal} />
                <DonateModal isOpen={isModalOpen} onClose={closeModal} />
            </div>
        </Router>
    );
};

export default App;
